import React, { FC, useState, useEffect } from 'react';
import IconButton from 'src/components/atoms/buttons/IconButton';
import { confirmModalViewStore } from 'src/store/modal';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import Parse from 'html-react-parser';
import _ from 'lodash';
import './style.scss';

interface Props {
  boxStyleDef?: React.CSSProperties;
  styleDef?: React.CSSProperties;
}

/**
 * Modal 확인 창 레이아웃
 */
const ModalConfirmLayout: FC<Props> = ({ boxStyleDef, styleDef }) => {
  const modalData = confirmModalViewStore((state: any) => state.data);
  const closeModalState = confirmModalViewStore((state: any) => state.close);
  const confirmEvt = modalData.confirmEvt;
  const cancleEvt = modalData.cancleEvt;
  const title = modalData.title || '';

  const closeEvt = () => {
    closeModalState({ content: null, active: '' });
  };
  return (
    <div className={['_modal_confirm_layout', modalData.active].join(' ')}>
      <div className="_bg_box" onClick={closeEvt} />
      <div className="_content_box " style={boxStyleDef}>
        <div className="_title_div">
          {title ? <div className="_title">{title}</div> : ''}
          <div className="_btn">
            <IconButton
              icon="ri-close-line"
              clickEvent={closeEvt}
              styleDef={{ fontSize: '25px', width: '25px', height: '25px' }}
            />
          </div>
        </div>
        <div className="_condtent_div" style={styleDef}>
          <div className="_content ">{modalData.content}</div>
        </div>
        <div className="_btn_div">
          <div className="_btn ">
            <DefaultButton text="확인" clickEvent={e => confirmEvt()} icon="" type="type4" />
          </div>
          <div className="_btn ">
            <DefaultButton text="취소" clickEvent={e => cancleEvt()} icon="" status="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalConfirmLayout;
